import React from 'react';
import { useLocation } from 'react-router-dom';
function SANSRS_Technical_Summary() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get('page') || 1;

  return (
    <div className="pdf-page">
    <iframe
      src={`pdf/Technical_Summary_for_SANSRS_v2_0.pdf#page=${page}`}
      title="PDF Document"
        width="100%"
        height="600px"
    />
  </div>
  );
}

export default SANSRS_Technical_Summary;
